import React from "react";
import styled from "styled-components/macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinusCircle, faPlusCircle } from "@fortawesome/free-solid-svg-icons";

const AddUnitBox = ({
  colorUnit,
  size,
  columnsLength,
  onAddItemPress,
  onRemoveColumnPress,
  columnIndex,
}) => {
  const onAddItem = (e) => {
    try {
      e?.target?.className?.includes("AddUnitBox__InnerWrapper") &&
        onAddItemPress({ size, columnIndex });
    } catch (e) {}
  };

  return (
    <div
      className="prop-detail"
      onClick={onAddItem}
      style={{ flexDirection: "row" }}
    >
      <Box>
        <Wrapper frameColor={colorUnit} size={96 * size}>
          {onAddItemPress ? (
            <InnerWrapper
              showDoor={false}
              color={"rgba(255,255,255,0.6)"}
              gradientColor={"rgba(255,255,255,0.2)"}
            >
              <FontAwesomeIcon
                onClick={() => onAddItemPress({ size, columnIndex })}
                size={"2x"}
                style={{ justifyContent: "center", cursor: "pointer" }}
                icon={faPlusCircle}
              />
              {size === 7 && columnsLength > 2 && (
                <FontAwesomeIcon
                  className="prop-detail2"
                  onClick={() => onRemoveColumnPress({ columnIndex })}
                  size={"2x"}
                  style={{
                    marginTop: "30px",
                    justifyContent: "center",
                    cursor: "pointer",
                  }}
                  icon={faMinusCircle}
                />
              )}
            </InnerWrapper>
          ) : (
            <InnerWrapper
              showDoor={false}
              color={"rgba(200,200,200,0.6)"}
              gradientColor={"rgba(200,200,200,0.2)"}
            />
          )}
        </Wrapper>
      </Box>
    </div>
  );
};

const Box = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
`;

const Wrapper = styled.div`
  /* pointer-events: none; */
  z-index: 4;
  width: 180px; //166px;
  height: ${({ size }) => size}px;
  //border: 7px solid ${({ frameColor }) => frameColor};
  align-items: center;
  justify-content: center;
  position: relative;
  display: flex;
  border-radius: 2px;
`;

const InnerWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: center;
  justify-items: center;
  align-items: center;
  /* // box-shadow: ${({ showDoor }) =>
    showDoor ? "0 3px 6px 0 rgba(0, 0, 0, 0.16)" : null}; */
  box-shadow: ${({ showDoor }) =>
    showDoor ? "inset 2px 2px 10px 5px rgba(0,0,0,0.16)" : null};
  background-image: linear-gradient(
    to bottom,
    ${({ color }) => color},
    ${({ gradientColor }) => gradientColor} 95%
  );
`;

export { AddUnitBox };
